/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ClimateActionRouteImport } from './routes/climate-action'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as EmergencyRouteImport } from './routes/emergency'
import { Route as RiskLevelsRouteImport } from './routes/risk-levels'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClimateActionRoute = ClimateActionRouteImport.update({
  id: '/climate-action',
  path: '/climate-action',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const EmergencyRoute = EmergencyRouteImport.update({
  id: '/emergency',
  path: '/emergency',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskLevelsRoute = RiskLevelsRouteImport.update({
  id: '/risk-levels',
  path: '/risk-levels',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/climate-action': typeof ClimateActionRoute
  '/dashboard': typeof DashboardRoute
  '/emergency': typeof EmergencyRoute
  '/risk-levels': typeof RiskLevelsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/climate-action': typeof ClimateActionRoute
  '/dashboard': typeof DashboardRoute
  '/emergency': typeof EmergencyRoute
  '/risk-levels': typeof RiskLevelsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/climate-action': typeof ClimateActionRoute
  '/dashboard': typeof DashboardRoute
  '/emergency': typeof EmergencyRoute
  '/risk-levels': typeof RiskLevelsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    '/' | '/climate-action' | '/dashboard' | '/emergency' | '/risk-levels'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/climate-action' | '/dashboard' | '/emergency' | '/risk-levels'
  id:
    | '__root__'
    | '/'
    | '/climate-action'
    | '/dashboard'
    | '/emergency'
    | '/risk-levels'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClimateActionRoute: typeof ClimateActionRoute
  DashboardRoute: typeof DashboardRoute
  EmergencyRoute: typeof EmergencyRoute
  RiskLevelsRoute: typeof RiskLevelsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/climate-action': {
      id: '/climate-action'
      path: '/climate-action'
      fullPath: '/climate-action'
      preLoaderRoute: typeof ClimateActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emergency': {
      id: '/emergency'
      path: '/emergency'
      fullPath: '/emergency'
      preLoaderRoute: typeof EmergencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk-levels': {
      id: '/risk-levels'
      path: '/risk-levels'
      fullPath: '/risk-levels'
      preLoaderRoute: typeof RiskLevelsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClimateActionRoute: ClimateActionRoute,
  DashboardRoute: DashboardRoute,
  EmergencyRoute: EmergencyRoute,
  RiskLevelsRoute: RiskLevelsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
